import { render } from "./NewUser.vue?vue&type=template&id=c98884e4&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=c98884e4&lang=scss&scoped=true"
import "./NewUser.vue?vue&type=style&index=1&id=c98884e4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98884e4"]])

export default __exports__